import React from "react";
import PropTypes from "prop-types";
import {
  ButtonItem,
  Title,
  InText,
  ItemData,
  Segmant,
  Wcomment,
  NewItemData,
  NewButtonItem,
} from "../../components";
import SplitText from "./SplitText";
import { Grid, Divider, Icon, Dropdown, Label } from "semantic-ui-react";
// import Link from "next/link";
import { Link, animateScroll as scroll } from "react-scroll";
import { styles } from "./element";
import Moment from "react-moment";

import { customdecodeURIComponent } from "../../common/Utils";
const NewDescription = ({
  desData,
  display,
  showMore,
  show,
  toggle,
  visibility,
  change,
  like,
  onLike,
  review,
  click,
  showeditbutton,
  onRate,
  is_display_review_txt,
  is_change_review_txt,
}) => {
  let max = desData.length;
  let data = showMore ? desData.slice(0, max) : desData.slice(0, 5);

  let length = 3;
  let limit = 1000;

  const rateoptions = [
    {
      key: "-1",
      text: "-1",
      value: "-1",
    },
    {
      key: "0",
      text: "0",
      value: "0",
    },
    {
      key: "1",
      text: "1",
      value: "1",
    },
    {
      key: "2",
      text: "2",
      value: "2",
    },
    {
      key: "3",
      text: "3",
      value: "3",
    },
    {
      key: "4",
      text: "4",
      value: "4",
    },
    {
      key: "5",
      text: "5",
      value: "5",
    },
  ];

  return (
    <div>
      {data.map((grid, index) => (
        <div key={index}>
          <Grid padded>
            <Grid.Column
              width={5}
              style={{ paddingRight: 0, paddingTop: 10, paddingBottom: 0 }}
            >
              <div className="usr_img_item">
                <NewItemData
                  size="tiny"
                  source={
                    grid.userDetails[0] &&
                    grid.userDetails[0].userimage !==
                      "$context.arguments.userimage" &&
                    grid.userDetails[0].userimage !== ""
                      ? grid.userDetails[0].userimage
                      : process.env.NEXT_PUBLIC_CDN_ID +
                        "static/images/userdefault.png"
                  }
                  head={
                    grid.userDetails[0] &&
                    grid.userDetails[0].displayname !== null &&
                    grid.userDetails[0].displayname !== "" &&
                    grid.userDetails[0].type != "realtor"
                      ? grid.userDetails[0].displayname
                      : grid.userDetails[0] &&
                        grid.userDetails[0].firstName +
                          " " +
                          grid.userDetails[0].lastName
                  }
                  subhead={
                    grid.userDetails[0] &&
                    grid.userDetails[0].type === "realtor"
                      ? "Real Estate Agent"
                      : ""
                  }
                  userid={grid.userDetails[0] && grid.userDetails[0].id}
                  // desc={grid.desc}
                  href="/ProfileRealtor/"
                />
              </div>
            </Grid.Column>
            <Grid.Column
              width={11}
              style={{ paddingLeft: 0, paddingTop: 7, paddingBottom: 0 }}
            >
              {grid.description.length <= limit ? (
                <div style={{ minHeight: "50px" }}>
                  <InText name={customdecodeURIComponent(grid.description)} />
                </div>
              ) : display[index] ? (
                <div className="showless_blk">
                  <InText
                    name={customdecodeURIComponent(grid.description)}
                    floated="left"
                  />
                  <span
                    style={{
                      display: "inherit",
                      cursor: "pointer",
                      width: "100%",
                      position: "relative",
                      top: -9,
                    }}
                    onClick={(e) => show(index, e)}
                  >
                    <Title
                      name="show less"
                      color="blue"
                      floated="right"
                      size="small"
                    />
                  </span>
                </div>
              ) : (
                <div className="showmore_blk">
                  <InText
                    name={
                      customdecodeURIComponent(grid.description).substring(
                        0,
                        limit,
                      ) + " ..."
                    }
                    //floated='left'
                  />
                  <span
                    style={{
                      display: "inherit",
                      cursor: "pointer",
                      width: "100%",
                      marginBottom: "5px",

                      //position: 'relative',
                      //top:-20
                    }}
                    onClick={(e) => show(index, e)}
                    className="showmore_span"
                  >
                    <Title
                      name="show more"
                      color="blue"
                      //floated='right'
                      size="small"
                      texttransform="none"
                    />
                    <div></div>
                  </span>
                </div>
              )}
              <span style={styles.date_item}>
                <Moment format="MM/DD/YYYY">{grid.createDate}</Moment>
              </span>
              <div className="helpcontent_blk">
                {/*{like[index] ?*/}
                {grid.helpedUserId === "1" || grid.helpStatus === 1 ? (
                  <NewButtonItem
                    name="desc"
                    onClick={(e) => onLike(index, e, grid, grid.id)}
                    basic
                    icon="thumbs up"
                    helpcontent={grid.helpcontent}
                    content={"Helpful " + grid.helpfulCount}
                  />
                ) : (
                  <NewButtonItem
                    name="desc"
                    onClick={(e) => onLike(index, e, grid, grid.id)}
                    basic
                    icon="thumbs up outline"
                    helpcontent={grid.helpcontent}
                    content={"Helpful " + grid.helpfulCount}
                  />
                )}
                <div className="rate_blk">
                  {grid.editor_rate !== "" && showeditbutton ? (
                    <>
                      <span className="rate_drpdwn_editor edit">
                        Rate {grid.editor_rate}
                      </span>
                      <span style={styles.rate_item} className="rate_drpdwn">
                        <Dropdown
                          text="Edit Rate"
                          //icon='add user'
                          floating
                          labeled
                          button
                        >
                          <Dropdown.Menu>
                            <Dropdown.Header content="Rate" />
                            {rateoptions.map((option) => (
                              <Dropdown.Item
                                key={option.value}
                                {...option}
                                onClick={(e) => onRate(index, e, grid, grid.id)}
                              />
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </span>
                    </>
                  ) : (
                    grid.editor_rate > 3 && (
                      <span className="rate_drpdwn_editor">Editor's pick</span>
                    )
                  )}
                  {/* {showeditbutton && grid.editor_rate === "-1" && (
                    <span style={styles.rate_item} className="rate_drpdwn">
                      <Dropdown
                        text="Rate"
                        //icon='add user'
                        floating
                        labeled
                        button
                      >
                        <Dropdown.Menu>
                          <Dropdown.Header content="Rate" />
                          {rateoptions.map((option) => (
                            <Dropdown.Item
                              key={option.value}
                              {...option}
                              onClick={(e) => onRate(index, e, grid, grid.id)}
                            />
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </span>
                  )} */}
                </div>
              </div>
            </Grid.Column>
          </Grid>
        </div>
      ))}

      {showMore ? (
        <div style={{ display: "table", margin: "0 auto", cursor: "pointer" }}>
          <span
            // style={{ display: "inline-block", cursor: "pointer", width: "100%" }}
            onClick={(e) => click(e)}
          >
            <Title
              name="Show Less Reviews"
              color="blue"
              size="small"
              floated="right"
              id="reply_box"
            />
          </span>
        </div>
      ) : desData.length > 5 ? (
        <div style={{ display: "table", margin: "0 auto", cursor: "pointer" }}>
          <span
            // style={{ display: "inline-block", cursor: "pointer", width: "100%" }}
            onClick={(e) => click(e)}
          >
            <Title
              name="Show More Reviews"
              color="blue"
              size="small"
              floated="right"
              id="reply_box"
            />
          </span>
        </div>
      ) : (
        ""
      )}
      <div className="no_review_sec">
        {data === [] || data.length <= 0 ? (
          <div className="no_reviews_blk">
            {!is_change_review_txt ? (
              <h3>Be the first to write a Review!</h3>
            ) : (
              <h3>Write a Review!</h3>
            )}
          </div>
        ) : (
          ""
        )}
      </div>

      {/* <div className="city_txt_btm">
        <span>
          See City Review for: <a href="#">Burlingame</a>
        </span>
      </div> */}

      {/* <Divider hidden />
      <Divider hidden /> */}
      {/* <Divider style={{ borderBottom: "1px solid #828282" }} /> */}
    </div>
  );
};

NewDescription.propTypes = {
  desData: PropTypes.array.isRequired,
};

export default NewDescription;
